import isNumber from "ramda/src/internal/_isNumber";

export default isNumber;
